const LAWYER_HOURLY_RATE = 391;

export default LAWYER_HOURLY_RATE;
